import {pageInfo, initUpdate, exportData, cancleSubmit} from "../api";
import {
  getWorkFlowLog,
  goodsCategory,
  plant,
  selectReshipLoadingType,
  storageList,
  getRcoStatus
} from '../../../../../api'

const coalShip = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    initUpdateObj: null,
    exportObj: null,
    cancleObj: null,
    plantCodeObj: null,
    goodesCategoryCodeObj: null,
    storageCodeObj: null,
    loadingTypeCodeDataObj: null,
    businessTypeObj: null,
    orderWorkFlowLogObj: null,
    rcoStatusObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj.map(item=>({...item, btns:[true,{disabled: item.cancelButtonShow !='Y' ? true : false}]})) || [];
    },
    UPDATE_INIT_DATA(state, data){
      state.initUpdateObj = data.obj;
    },
    EXPORT_DATA(state, data){
      state.exportObj = data;
    },
    CANCLE_DATA(state, data){
      state.cancleObj = data;
    },

    PLANT_CODE_DATA(state, data){
      state.plantCodeObj = data;
    },
    GOODS_CATEGORY_CODE_DATA(state, data){
      state.goodesCategoryCodeObj = data;
    },
    STORAGE_CODE_DATA(state, data){
      state.storageCodeObj = data;
    },
    LOADING_TYPE_CODE_DATA(state, data){
      state.loadingTypeCodeDataObj = data;
    },
    BUSINESS_TYPE_DATA(state, data){
      state.businessTypeObj = data;
    },
    GET_ORDER_WORK_FLOW_LOG(state, data){
      state.orderWorkFlowLogObj = data;
    },
    RCO_STATUS_DATA(state, data){
      state.rcoStatusObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //修改初始化
    async initUpdate({ commit }, obj) {
      let resp = await initUpdate(obj);
      commit('UPDATE_INIT_DATA', resp);
    },
    //运作单导出
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //取消
    async cancleSubmit({ commit }, obj) {
      let resp = await cancleSubmit(obj);
      commit('CANCLE_DATA', resp);
    },

    //基地
    async getPlantCodeList({ commit }, obj) {
      let resp = await plant(obj);
      commit('PLANT_CODE_DATA', resp);
    },
    //货物类型
    async getGoodsCategoryCodeList({ commit }, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY_CODE_DATA', resp);
    },
    //发出库位
    async getStorageCodeList({ commit }, obj) {
      let resp = await storageList(obj);
      commit('STORAGE_CODE_DATA', resp);
    },
    //装货类型
    async getLoadingTypeCodeList({ commit }, obj) {
      let resp = await selectReshipLoadingType(obj);
      commit('LOADING_TYPE_CODE_DATA', resp);
    },
    //玉米倒运运作单状态
    async getRcoStatus({ commit }, obj) {
      let resp = await getRcoStatus(obj);
      commit('RCO_STATUS_DATA', resp);
    },
    //运作单流程详情
    async getOrderWorkFlowLog({ commit }, obj) {
      let resp = await getWorkFlowLog(obj);
      commit('GET_ORDER_WORK_FLOW_LOG', resp);
    },
  }
}
export default coalShip



// WEBPACK FOOTER //
// ./src/page/bd/corn/reshipCornOrder/store/reshipCornOrder.store.js